module.exports = __webpack_public_path__ + "media/yay.46c744f5.mp3";